import { render, staticRenderFns } from "./updatePartner.vue?vue&type=template&id=47b83a59"
import script from "./updatePartner.vue?vue&type=script&lang=js"
export * from "./updatePartner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports